import { render, staticRenderFns } from "./SelectAccess.vue?vue&type=template&id=1320003c&scoped=true&"
import script from "./SelectAccess.vue?vue&type=script&lang=js&"
export * from "./SelectAccess.vue?vue&type=script&lang=js&"
import style0 from "./SelectAccess.vue?vue&type=style&index=0&id=1320003c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1320003c",
  null
  
)

export default component.exports